import { render, staticRenderFns } from "./XQuickDeleteButton.vue?vue&type=template&id=39a5d100"
import script from "./XQuickDeleteButton.vue?vue&type=script&lang=js"
export * from "./XQuickDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports